// src/App.js
import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { Box } from '@mui/material';
import Header from './components/Header';
import Footer from './components/Footer';
import ErrorBoundary from './components/ErrorBoundary';
import Home from './Pages/Home';
import MenuPage from './Pages/Menu';
import CateringPage from './Pages/Catering';
import NotFound from './Pages/NotFound';

const GA_ID = 'G-9WP6NS3W0H';

function PageTracker() {
  const location = useLocation();

  useEffect(() => {
    if (typeof window.gtag !== 'function') return;
    window.gtag('config', GA_ID, {
      page_path: location.pathname + location.search,
    });
  }, [location]);

  return null;
}

function App() {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Header />
      <PageTracker />
      <Box sx={{ flex: 1 }}>
        <ErrorBoundary fallbackMessage="Something went wrong. Please refresh the page.">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/menu" element={<MenuPage />} />
            <Route path="/catering" element={<CateringPage />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </ErrorBoundary>
      </Box>
      <Footer />
    </Box>
  );
}

export default App;
